import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "marketingOptIn" */ './MarketingOptIn')));

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'MarketingOptIn');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as MarketingOptIn };
